module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ka":{"contactDoctor":"დაუკავშირდი ექიმს","contactClinic":"დაუკავშირდი კლინიკას","openChat":"პასუხის გაცემა","chatIsInactive":"ჩატი პასიურია"},"en":{"contactDoctor":"Contact Doctor","contactClinic":"Contact Clinic","openChat":"Open Chat","chatIsInactive":"Chat is inactive"}}')
  delete Component.options._Ctor
}
